import { useEffect, useState } from 'react';

interface IUseCountUpOptions {
  duration?: number;
  decimals?: number;
  disabled?: boolean;
}

export const useCountUp = (end: number, options: IUseCountUpOptions = {}) => {
  const { duration = 1000, decimals = 0, disabled = false } = options;

  const [value, setValue] = useState<number>(disabled ? end : 0);

  useEffect(() => {
    if (disabled) {
      setValue(end);
      return;
    }

    let startTs: number | undefined;
    let rafId = 0;

    const startValue = 0;
    const diff = end - startValue;
    const factor = Math.pow(10, decimals);

    const step = (ts: number) => {
      if (startTs === undefined) startTs = ts;
      const elapsed = ts - startTs;
      const progress = Math.min(elapsed / duration, 1);
      const current = startValue + diff * progress;
      const rounded = Math.round(current * factor) / factor;
      setValue(rounded);
      if (progress < 1) {
        rafId = requestAnimationFrame(step);
      }
    };

    setValue(startValue);
    rafId = requestAnimationFrame(step);

    return () => {
      if (rafId) cancelAnimationFrame(rafId);
    };
  }, [end, duration, decimals, disabled]);

  return disabled ? end : value;
};

export default useCountUp;
